import {
	REQUEST_SIMPLE_SEARCH_RESULTS,
	RECEIVE_SIMPLE_SEARCH_RESULTS,
	SET_SIMPLE_SEARCH_RESULTS_ERROR,
	SIMPLE_SEARCH_WRONG_QUERY_ERROR,
	SET_SIMPLE_SEARCH_RESULTS_TAB,
	SET_FILTER,
	CLEAN_ALL_FILTERS,
	CLEAN_ALL_FILTERS_HEADINGS,
	APPLY_FILTER,
	EXPAND_TREE,
	REQUEST_LOAD_FILTER_BY_NAME,
	RECEIVE_LOAD_FILTER_BY_NAME,
	LOAD_FILTER_BY_NAME_ERROR,
	REMOVE_FROM_APPLIED,
	IS_FIELDS_OPEN,
	SET_TAB_NAV,
	RESET_TAB_NAV,
	RESET_FILTERS,
	SET_IS_BLOCKED,
	RESET_IS_BLOCKED,
	RESET_APPLY_FILTER,
	UPDATE_HEADING_FILTERS,
	RESET_HEADINGS_FILTERS,
	UPDATE_HEADING_FILTERS_SELECT_RELATED,
	UPDATE_HEADING_FILTERS_SELECT
} from '../constants/ActionTypes';
import filtersAppliedResponse from '../scripts/AppliedFilters.js';

const initialState = {
	isFetching: false,
	isLoadingError: false,
	isFetchingFilterByName: false,
	isFilterByNameError: false,
	isWrongQuery: false,
	applyHeadingFilters: false,
	applyFilters: false,
	ipp: [
		{
			val: 25,
		},
		{
			val: 50,
		},
		{
			val: 100,
		},
	],
	resultsList: [],
	tabs: [],
	appliedFilters: [],
	tabNav: [],
	isFieldsOpen: false,
	queryKey: '',
	isBlocked: false
};

export default function simpleResults(state = initialState, action) {
	switch (action.type) {
		case SET_IS_BLOCKED:
			return {
				...state,
				isBlocked: action.val
			};
		case RESET_IS_BLOCKED:
			return {
				...state,
				isBlocked: false
			};
		case IS_FIELDS_OPEN:
			return {
				...state,
				isFieldsOpen: action.isOpened
			};
		case RESET_APPLY_FILTER:
			return {
				...state,
				applyHeadingFilters: false,
				applyFilters: false,
			};
		// *****ERRORS*****
		case SIMPLE_SEARCH_WRONG_QUERY_ERROR:
			return {
				...state,
				isWrongQuery: true,
				isFetching: false,
				isLoadingError: false
			};
		case SET_SIMPLE_SEARCH_RESULTS_ERROR:
			return {
				...state,
				isFetching: false,
				isLoadingError: true,
				isWrongQuery: false
			};
		// *****TABS*****
		case SET_SIMPLE_SEARCH_RESULTS_TAB:
			return {
				...state,
				tabs: state.tabs.map(tab => ((tab.active && tab.name !== action.name) || (!tab.active && tab.name === action.name)) ?
					{
						...tab,
						active: !tab.active
					}
					: tab),
			};
		// *****RESULTS*****
		case REQUEST_SIMPLE_SEARCH_RESULTS:
			return {
				...state,
				isFetching: true,
				isLoadingError: false,
				isWrongQuery: false,
				applyHeadingFilters: false,
				applyFilters: false,
			};
		case RECEIVE_SIMPLE_SEARCH_RESULTS:
			const activeTab = action.results.tabs.filter(tab => tab.active)[ 0 ];
			return {
				...state,
				isFetching: false,
				headingFilters: action.results.headingFilters.map(headingFilter => {
					return {
						...headingFilter,
						selected: headingFilter.options && headingFilter.options.filter(option => option.selected).length > 0
					}
				}),
				headingId: action.results.headingId,
				resultsList: activeTab ? activeTab.results : [],
				tabs: action.results.tabs.map(tab => {
					return {
						...tab,
						totalPages: tab.count > 0 ? Math.ceil(tab.count / tab.perPage) : 1
					}
				}),
				appliedFilters: activeTab && activeTab.allowedFilters ? filtersAppliedResponse(state.appliedFilters, activeTab) : [],
				tabNav: activeTab ? [
					...state.tabNav.filter(tab => tab.name !== activeTab.name),
					activeTab ? {
						name: activeTab.name,
						options: [
							{ type: 'ipp', value: activeTab.perPage },
							{ type: 'sorting', value: activeTab.sorting },
							{ type: 'page', value: activeTab.page },
						].filter(option => option.value)
					} : false
				].filter(option => option) : [],
				queryKey: action.results.query
			};

		// *****FILTERS*****
		case APPLY_FILTER:
			return {
				...state,
				applyFilters: true,
				appliedFilters: state.appliedFilters.filter(filter => filter.id === action.fieldName && action.data.tab === filter.tab).length < 1 ?
					[
						...state.appliedFilters,
						{
							id: action.fieldName,
							label: action.fieldName,
							value: action.data.value,
							tab: action.data.tab,
							type: action.data.type,
						}
					]
					: action.data.value.filter(dataItem => dataItem.id !== '').length > 0 ?
						state.appliedFilters.map(filter => filter.id === action.fieldName && action.data.tab === filter.tab ?
							{
								...filter,
								value: action.data.value
							}
							: filter)
						: state.appliedFilters.filter(filter => !(filter.id === action.fieldName && action.data.tab === filter.tab))
			};
		case EXPAND_TREE:
			const updateTreeNode = filters => {
				return filters.map(filter => filter.id === action.id ?
					{
						...filter,
						expansible: false,
						children: action.data.children
					}
					: filter.children ?
						{
							...filter,
							children: updateTreeNode(filter.children)
						}
						: filter);
			};

			return {
				...state,
				tabs: state.tabs.map(tab => tab.active ?
					{
						...tab,
						allowedFilters: tab.allowedFilters.map(dataItem => dataItem.type === "TREE_ID" ?
							{
								...dataItem,
								options: updateTreeNode(dataItem.options)
							}
							: dataItem)
					}
					: tab)
			};
		case REQUEST_LOAD_FILTER_BY_NAME:
			return {
				...state,
				tabs: state.tabs.map(tab => tab.name === action.tabName ?
					{
						...tab,
						allowedFilters: tab.allowedFilters.map(tabFilter => tabFilter.name === action.fieldName ?
							{
								...tabFilter,
								isLoading: true,
								isError: false
							}
							: tabFilter)
					}
					: tab),
			};
		case LOAD_FILTER_BY_NAME_ERROR:
			return {
				...state,
				tabs: state.tabs.map(tab => tab.name === action.tabName ?
					{
						...tab,
						allowedFilters: tab.allowedFilters.map(tabFilter => tabFilter.name === action.fieldName ?
							{
								...tabFilter,
								isLoading: false,
								isError: true
							}
							: tabFilter)
					}
					: tab),
			};
		case RECEIVE_LOAD_FILTER_BY_NAME:
			return {
				...state,
				tabs: state.tabs.map(tab => tab.name === action.tabName ?
					{
						...tab,
						allowedFilters: tab.allowedFilters.map(tabFilter => tabFilter.name === action.fieldName ?
							{
								...tabFilter,
								options: action.results,
								isLoading: false,
								isFiltered: true
							}
							: tabFilter)
					}
					: tab),
			};
		case REMOVE_FROM_APPLIED:
			return {
				...state,
				appliedFilters: state.appliedFilters.map(filter => filter.id === action.name && action.tab === filter.tab ?
					{
						...filter,
						value: filter.value.filter(filterValue => filterValue.id !== action.id)
					}
					: filter)
					.filter(filter => filter.value.length > 0),
				applyFilters: true
			};
		case SET_TAB_NAV:
			return {
				...state,
				tabNav: state.tabNav.filter(tab => tab.name === action.fieldName).length > 0 ?
					state.tabNav.map(tab => tab.name === action.fieldName ?
						{
							...tab,
							options: [
								...tab.options.filter(option => action.options.filter(actionOption => actionOption.type === option.type).length === 0),
								...action.options
							]
						}
						: tab)
					: [
						...state.tabNav,
						{ name: action.fieldName, options: action.options }
					]
			};
		case SET_FILTER:
			const selectFilters = filters => {
				return filters.map(filter => filter.id === action.id ?
					{
						...filter,
						selected: !filter.selected
					}
					: filter)
					.map(filter => filter.children && filter.children.length > 0 ?
						{
							...filter,
							children: selectFilters(filter.children)
						}
						: filter);
			};

			return {
				...state,
				tabs: state.tabs.map(tab => tab.active ?
					{
						...tab,
						allowedFilters: tab.allowedFilters.map(filterData => filterData.name === action.fieldName ?
							{
								...filterData,
								options: selectFilters(filterData.options)
							}
							: filterData)
					}
					: tab),
			};
		case CLEAN_ALL_FILTERS:
			const activeTabCleanAll = state.tabs.filter(tab => tab.active)[ 0 ];

			return {
				...state,
				appliedFilters: state.appliedFilters.filter(filter => filter.tab !== activeTabCleanAll.name),
				applyFilters: true,
				isBlocked: false
			};
		case CLEAN_ALL_FILTERS_HEADINGS:
			const activeTabCleanAllHeadings = state.tabs.filter(tab => tab.active)[ 0 ];

			return {
				...state,
				appliedFilters: state.appliedFilters.filter(filter => (filter.tab !== activeTabCleanAllHeadings.name && filter.tab !== 'common') || filter.id === 'HEADINGS'),
				applyFilters: true,
				isBlocked: false
			};
		case RESET_FILTERS:
			return {
				...state,
				appliedFilters: []
			};
		case RESET_HEADINGS_FILTERS:
			return {
				...state,
				headingFilters: []
			};
		case UPDATE_HEADING_FILTERS:
			return {
				...state,
				applyFilters: true,
				applyHeadingFilters: true,
				appliedFilters: [],
				//FAKE SELECTED
				headingFilters: state.headingFilters.map(headingFilter => { return { ...headingFilter, selected: headingFilter.name === action.fieldName } })
			};
		case UPDATE_HEADING_FILTERS_SELECT:
			return {
				...state,
				applyFilters: true,
				applyHeadingFilters: true,
				//FAKE SELECTED
				// headingFiltersSelect: state.headingFiltersSelect ?
				//     state.headingFiltersSelect.filter(elem => elem.id === action.name).length > 0 ?
				//       state.headingFiltersSelect.map(elem =>
				//         elem.id === action.name ?
				//           {...elem, value: action.value.id}
				//           : elem)
				//         : [...state.headingFiltersSelect, {id: action.name, value: action.value.id}]
				//     : [{id: action.name, value: action.value.id}],
				headingFiltersSelect: [ { id: action.name, value: action.value.id } ],
				headingFilters: []
			};
		case UPDATE_HEADING_FILTERS_SELECT_RELATED:
			return {
				...state,
				applyFilters: true,
				applyHeadingFilters: true,
				//FAKE SELECTED
				headingFiltersSelect: state.headingFiltersSelect ?
					state.headingFiltersSelect.filter(elem => elem.id === action.name).length > 0 ?
						state.headingFiltersSelect.map(elem =>
							elem.id === action.name ?
								{ ...elem, value: action.value.id }
								: elem)
						: [ ...state.headingFiltersSelect, { id: action.name, value: action.value.id } ]
					: [ { id: action.name, value: action.value.id } ],
				headingFilters: []
			};
		case RESET_TAB_NAV:
			return {
				...state,
				tabNav: []
			};
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/reducers/simpleSearchResults.js